import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    banks: [],
    banksCount: 0,
    bank: {},
    bankSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getBanks(state) {
      return state.banks
    },
    getBanksCount(state) {
      return state.banksCount
    },
    getBank(state) {
      return state.bank
    },
    getBankSaveStatus(state) {
      return state.bankSave
    },
  },
  mutations: {
    BANKS_LIST(state, data) {
      state.banks = data
    },
    BANK_VIEW(state, data) {
      state.bank = data
    },
    BANKS_COUNT(state, data) {
      state.banksCount = data
    },
    BANK_SAVE(state, data) {
      state.bankSave = data
    },
  },
  actions: {
    banksList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/hrDefines/banks', data)
        .then(response => {
          commit('BANKS_LIST', response.data.data)
          commit('BANKS_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    bankView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'banks.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/hrDefines/banks', data)
        .then(response => {
          commit('BANK_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    bankSave({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post('/hrDefines/banks/saveData', data)
        .then(response => {
          commit('BANK_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
